export default "__VITE_ASSET__a4ze9rxt__"